// Constants used across the Month Calendar components

export const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

export const STATUS_ICONS = {
  cancelled_no_show: {
    icon: "DoNotDisturbIcon",
    color: "legend.noShow",
  },
  cancelled: {
    icon: "CancelOutlinedIcon",
    color: "legend.canceled",
  },
  pending: {
    icon: "DoDisturbOnOutlinedIcon",
    color: "legend.pending",
  },
  finished: {
    icon: "CheckCircleOutlinedIcon",
    color: "legend.finished",
  },
}

export const MAX_CHARS = {
  MOBILE: 10, // for screens < 768px
  TABLET: 12, // for screens < 1024px
  DESKTOP: 15, // for screens >= 1024px
}
